export * from './crypto'
export * from './date'
export * from './event-bus'
export * from './rule'
export * from './storage'
export * from './validate'
export * from './bom'
export * from './cookie'

/**
 * 判断线上环境是否外网：以 ata.360.net 或 ata.360.cn 结尾的域名视为外网
 */
export const IS_PRODUCT_HOST = window.location.hostname.endsWith('ata.360.net') || window.location.hostname.endsWith('ata.360.cn')
/**
 * 判断线上环境是否内网：以 ata.360zqaq.net 结尾的域名视为内网，其他默认为外网
 */
export const IS_QIHOO_HOST = window.location.hostname.endsWith('ata.360zqaq.net')
